import convertObjectPropertiesTypes from "../../../../helpers/convertors/object-properties-types-converter";
import populateMissingEhr from "../populate-missing-ehr";

export default function processEhr(ehr, missingEhr) {
  return populateMissingEhr(convertObjectPropertiesTypes(ehr), missingEhr);
}
